import { defineMessages } from 'react-intl';

export default defineMessages({
  billingPayments: {
    id: 'usecore.billing.payments',
    defaultMessage: 'Pagamentos',
  },
  billingUpdateDataError: {
    id: 'usecore.billing.updateDataError',
    defaultMessage: 'Não foi possível salvar os dados atualizados. Tente novamente.',
  },
  billingFetchDataError: {
    id: 'usecore.billing.fetchDataError',
    defaultMessage: 'Não foi possível buscar os dados. Atualize a tela e tente novamente.',
  },
  billingPackageUpdated: {
    id: 'usecore.billing.packageUpdated',
    defaultMessage: 'O pacote foi alterado com sucesso',
  },
  cepInvalid: {
    id: 'usecore.client.cepInvalid',
    defaultMessage: 'CEP Inexistente. Insira outro e tente novamente',
  },
  requestFailed: {
    id: 'usecore.client.requestFailed',
    defaultMessage: 'Não foi possível antender a sua solicitação.',
  },
  cpfAlreadyRegistered: {
    id: 'usecore.client.cpfAlreadyRegistered',
    defaultMessage: 'CPF já cadastrado no sistema.',
  },
  changesSaved: {
    id: 'usecore.client.changesSaved',
    defaultMessage: 'Alterações salvas com sucesso. 2',
  },
  clientAdded: {
    id: 'usecore.client.clientAdded',
    defaultMessage: 'Cliente adicionado com sucesso.',
  },
  bondRemoved: {
    id: 'usecore.client.bondRemoved',
    defaultMessage: 'Vínculo removido com sucesso.',
  },
  modalClose: {
    id: 'usecore.modal.close',
    defaultMessage: 'Fechar',
  },
  billingGeneral: {
    id: 'usecore.billing.general',
    defaultMessage: 'Geral',
  },
  billingSubscription: {
    id: 'usecore.billing.subscription',
    defaultMessage: 'Assinatura',
  },
  billingPayments: {
    id: 'usecore.billing.payments',
    defaultMessage: 'Pagamentos',
  },
  billingUpdateError: {
    id: 'usecore.billing.updateError',
    defaultMessage: 'Não foi possível salvar os dados atualizados. Tente novamente.',
  },
  billingFetchError: {
    id: 'usecore.billing.fetchError',
    defaultMessage: 'Não foi possível buscar os dados. Atualize a tela e tente novamente.',
  },
  billingPackageError: {
    id: 'usecore.billing.packageError',
    defaultMessage: 'Não foi possível alterar o pacote. Verifique a conexão com a internet',
  },
  billingActionError: {
    id: 'usecore.billing.actionError',
    defaultMessage: 'Não foi possível Executar essa ação',
  },
  billingPaymentMethodUpdated: {
    id: 'usecore.billing.paymentMethodUpdated',
    defaultMessage: 'Método de pagamento atualizado com sucesso',
  },
  billingUsersUpdated: {
    id: 'usecore.billing.usersUpdated',
    defaultMessage: 'Quantidade de usuários atualizada com sucesso',
  },
  billingPaymentSuccess: {
    id: 'usecore.billing.paymentSuccess',
    defaultMessage: 'Pagamento realizado com sucesso',
  },
  billingBoletoSent: {
    id: 'usecore.billing.boletoSent',
    defaultMessage: 'Boleto enviado com sucesso',
  },
  billingCepInvalid: {
    id: 'usecore.billing.cepInvalid',
    defaultMessage: 'CEP inválido',
  },
  billingFetchDataError: {
    id: 'usecore.billing.fetchDataError',
    defaultMessage: 'Não foi possível buscar os dados. Atualize a tela e tente novamente.',
  },
  invoicePdf: {
    id: 'usecore.invoice.pdf',
    defaultMessage: 'PDF',
  },
  invoiceXml: {
    id: 'usecore.invoice.xml',
    defaultMessage: 'XML',
  },
  invoicePayNow: {
    id: 'usecore.invoice.payNow',
    defaultMessage: 'Pagar Agora',
  },
  invoicePaid: {
    id: 'usecore.invoice.paid',
    defaultMessage: 'Quitado',
  },
  invoiceId: {
    id: 'usecore.invoice.id',
    defaultMessage: 'ID',
  },
  invoiceDate: {
    id: 'usecore.invoice.date',
    defaultMessage: 'Data',
  },
  invoicePaymentMethod: {
    id: 'usecore.invoice.paymentMethod',
    defaultMessage: 'Método de Pagamento',
  },
  invoiceBoleto: {
    id: 'usecore.invoice.boleto',
    defaultMessage: 'Boleto',
  },
  invoiceCreditCard: {
    id: 'usecore.invoice.creditCard',
    defaultMessage: 'Cartão de Crédito',
  },
  invoiceValue: {
    id: 'usecore.invoice.value',
    defaultMessage: 'Valor',
  },
  invoicePay: {
    id: 'usecore.invoice.pay',
    defaultMessage: 'Pagar',
  },
  invoiceDownloadNfe: {
    id: 'usecore.invoice.downloadNfe',
    defaultMessage: 'Download NFE',
  },
  invoicePayments: {
    id: 'usecore.invoice.payments',
    defaultMessage: 'Pagamentos',
  },
  invoicePaymentHistory: {
    id: 'usecore.invoice.paymentHistory',
    defaultMessage: 'Histórico de pagamentos',
  },
  modalCurrentUsers: {
    id: 'usecore.modal.currentUsers',
    defaultMessage: 'Quantidade de usuários atual',
  },
  modalValue: {
    id: 'usecore.modal.value',
    defaultMessage: 'Valor',
  },
  modalUsers: {
    id: 'usecore.modal.users',
    defaultMessage: '{count, plural, one {usuário} other {usuários}}',
  },
  modalNewUsers: {
    id: 'usecore.modal.newUsers',
    defaultMessage: 'Nova quantidade de usuários',
  },
  modalNextInvoice: {
    id: 'usecore.modal.nextInvoice',
    defaultMessage: 'Valor a ser cobrado na próxima fatura:',
  },
  modalRemoveAccess: {
    id: 'usecore.modal.removeAccess',
    defaultMessage: 'Remover acesso de usuário',
  },
  modalSelectUsers: {
    id: 'usecore.modal.selectUsers',
    defaultMessage: 'Selecione {count} {count, plural, one {usuário} other {usuários}} para confirmar operação',
  },
  modalCancel: {
    id: 'usecore.modal.cancel',
    defaultMessage: 'Cancelar',
  },
  modalConfirm: {
    id: 'usecore.modal.confirm',
    defaultMessage: 'Confirmar',
  },
  modalChangeUsers: {
    id: 'usecore.modal.changeUsers',
    defaultMessage: 'Altere o número de usuários:',
  },
  modalHelp: {
    id: 'usecore.modal.help',
    defaultMessage: 'Ajuda',
  },
  modalSelectDifferentNumber: {
    id: 'usecore.modal.selectDifferentNumber',
    defaultMessage: 'Por favor, selecione um número de usuários diferente do atual :)',
  },
  modalOk: {
    id: 'usecore.modal.ok',
    defaultMessage: 'OK',
  },
  subscriptionTitle: {
    id: 'usecore.subscription.title',
    defaultMessage: 'Assinatura',
  },
  subscriptionCurrent: {
    id: 'usecore.subscription.current',
    defaultMessage: 'Assinatura atual',
  },
  subscriptionProduct: {
    id: 'usecore.subscription.product',
    defaultMessage: 'Produto',
  },
  subscriptionPrice: {
    id: 'usecore.subscription.price',
    defaultMessage: 'Preço',
  },
  subscriptionWorkspaces: {
    id: 'usecore.subscription.workspaces',
    defaultMessage: 'Nº de workspaces:',
  },
  subscriptionUsers: {
    id: 'usecore.subscription.users',
    defaultMessage: 'Nº de usuários:',
  },
  subscriptionTotalValue: {
    id: 'usecore.subscription.totalValue',
    defaultMessage: 'Valor total',
  },
  subscriptionAutoRenewal: {
    id: 'usecore.subscription.autoRenewal',
    defaultMessage: 'Renovação Automática',
  },
  subscriptionChangeUsers: {
    id: 'usecore.subscription.changeUsers',
    defaultMessage: 'Alterar quantidade de usuários',
  },
  subscriptionHelpTitle: {
    id: 'usecore.subscription.helpTitle',
    defaultMessage: 'Ajuda',
  },
  subscriptionHelpMessage: {
    id: 'usecore.subscription.helpMessage',
    defaultMessage: 'Olá {name}, para melhor atendermos as suas necessidades, entre em contato com nosso time de consultores especializados utilizando o chat disponível no sistema.',
  },
  subscriptionHelpMessage2: {
    id: 'usecore.subscription.helpMessage2',
    defaultMessage: 'O chat fica no canto inferior direito do sistema :)',
  },
  subscriptionHelpMessage3: {
    id: 'usecore.subscription.helpMessage3',
    defaultMessage: 'Informe ao consultor que deseja aumentar ou reduzir usuários ao seu plano anual. Ele irá entender suas necessidades e te ajudar da melhor maneira possível.',
  },
  subscriptionHelpMessage4: {
    id: 'usecore.subscription.helpMessage4',
    defaultMessage: 'Aguardamos seu contato pelo chat :)',
  },
  subscriptionEnableAutoRenewal: {
    id: 'usecore.subscription.enableAutoRenewal',
    defaultMessage: 'Habilitar a renovação automática?',
  },
  subscriptionDisableAutoRenewal: {
    id: 'usecore.subscription.disableAutoRenewal',
    defaultMessage: 'Desabilitar a renovação automática?',
  },
  subscriptionEnableAutoRenewalMessage: {
    id: 'usecore.subscription.enableAutoRenewalMessage',
    defaultMessage: 'Ao habilitar a renovação automática, será realizada a cobrança sempre no fim da data de seu plano. Deseja prosseguir?',
  },
  subscriptionDisableAutoRenewalMessage: {
    id: 'usecore.subscription.disableAutoRenewalMessage',
    defaultMessage: 'Ao desabilitar a renovação automática, o usuário vinculado como administrador do negócio deverá contratar um novo plano. Deseja prosseguir?',
  },
  subscriptionNo: {
    id: 'usecore.subscription.no',
    defaultMessage: 'Não',
  },
  subscriptionYes: {
    id: 'usecore.subscription.yes',
    defaultMessage: 'Sim',
  },
  subscriptionBillingData: {
    id: 'usecore.subscription.billingData',
    defaultMessage: 'Dados de cobrança',
  },
  subscriptionBillingDataTooltip: {
    id: 'usecore.subscription.billingDataTooltip',
    defaultMessage: 'Utilizaremos os dados abaixo para realizar contatos referentes ao status financeiro deste negócio e para emissão de nota fiscal',
  },
  paymentMethodTitle: {
    id: 'usecore.paymentMethod.title',
    defaultMessage: 'Métodos de pagamento',
  },
  paymentMethodCurrent: {
    id: 'usecore.paymentMethod.current',
    defaultMessage: 'Seu método de pagamento atual é',
  },
  paymentMethodCreditCardWith: {
    id: 'usecore.paymentMethod.creditCardWith',
    defaultMessage: 'Cartão de Crédito {brand} com inicial',
  },
  paymentMethodBoleto: {
    id: 'usecore.paymentMethod.boleto',
    defaultMessage: 'Boleto Bancário',
  },
  paymentMethodChange: {
    id: 'usecore.paymentMethod.change',
    defaultMessage: 'Clique aqui se deseja trocar de método de pagamento',
  },
  actionsSave: {
    id: 'usecore.actions.save',
    defaultMessage: 'Salvar',
  },
  actionsSaving: {
    id: 'usecore.actions.saving',
    defaultMessage: 'Salvando...',
  },
  billingInfoUseCpf: {
    id: 'usecore.billingInfo.useCpf',
    defaultMessage: 'Usar CPF',
  },
  billingInfoUseCnpj: {
    id: 'usecore.billingInfo.useCnpj',
    defaultMessage: 'Usar CNPJ',
  },
  billingInfoName: {
    id: 'usecore.billingInfo.name',
    defaultMessage: 'Nome',
  },
  billingInfoLastName: {
    id: 'usecore.billingInfo.lastName',
    defaultMessage: 'Sobrenome',
  },
  billingInfoEmail: {
    id: 'usecore.billingInfo.email',
    defaultMessage: 'Email',
  },
  billingInfoCpf: {
    id: 'usecore.billingInfo.cpf',
    defaultMessage: 'CPF',
  },
  billingInfoCnpj: {
    id: 'usecore.billingInfo.cnpj',
    defaultMessage: 'CNPJ',
  },
  billingInfoCep: {
    id: 'usecore.billingInfo.cep',
    defaultMessage: 'CEP',
  },
  billingInfoAddress: {
    id: 'usecore.billingInfo.address',
    defaultMessage: 'Endereço',
  },
  billingInfoComplement: {
    id: 'usecore.billingInfo.complement',
    defaultMessage: 'Complemento',
  },
  billingInfoNeighborhood: {
    id: 'usecore.billingInfo.neighborhood',
    defaultMessage: 'Bairro',
  },
  billingInfoCity: {
    id: 'usecore.billingInfo.city',
    defaultMessage: 'Cidade',
  },
  billingInfoState: {
    id: 'usecore.billingInfo.state',
    defaultMessage: 'Estado',
  },
});
